import { DashboardMenu, NewLeaderBoard, Username, Countdown } from '@/app/shared/components';
import { useState } from 'react';
import { FaBars } from 'react-icons/fa6';
import { FaBagShopping } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
/////////////////////////////////////////////////////////////
import { useCustomSelector } from '@/core/redux/hooks';

export const DashboardHeader: React.FC = () => {
	/*********************
	// #region Redux
	**********************/
	const { seasons } = useCustomSelector((state) => state.seasons);

	/*********************
	// #region States
	**********************/
	const [visibleDrawerMenu, setVisibleDrawerMenu] = useState<boolean>(false);
	const [visibleLeaderBoard, setVisibleLeaderBoard] = useState<boolean>(false);

	/*********************
	// #region Computed
	**********************/
	// Get the active season or the first season if available
	const activeSeason = seasons.find(season => season.isActive) || seasons[0];

	/*********************
	// #region Functions
	**********************/
	const handleCloseMenu = () => {
		setVisibleDrawerMenu(false);
	};

	const handleCloseLeaderBoard = () => {
		setVisibleLeaderBoard(false);
	};
	/*********************
	// #region Template
	**********************/
	return (
		<div className="p-4">
			<div className="flex justify-between w-full items-center ">
				<div
					onClick={() => setVisibleDrawerMenu(true)}
				>
					<Username />
				</div>

				<div className="flex gap-3">
					{process.env.VITE_ENABLE_SHOP && (
						<div className="text-2xl mt-[-2px]">
							<Link to={'/shop'}>
								<FaBagShopping />
							</Link>
						</div>
					)}

					<div
						className="text-2xl"
						onClick={() => setVisibleLeaderBoard(true)}
					>
						<FaBars />
					</div>
				</div>

				{visibleLeaderBoard && (
					<NewLeaderBoard
						isOpen={visibleLeaderBoard}
						onClose={handleCloseLeaderBoard}
					/>
				)}
				{visibleDrawerMenu && (
					<DashboardMenu
						isOpen={visibleDrawerMenu}
						onClose={handleCloseMenu}
					/>
				)}
			</div>
			
			{/* Season Countdown */}
			{activeSeason && activeSeason.endDate && (
				<div className="text-center mt-2 text-sm text-gray-300">
					<Countdown endDate={activeSeason.endDate} />
				</div>
			)}
			
			{/* </div> */}
		</div>
	);
};
